"use client";

import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Pillars from "../Pillars";
import Cycle from "../Cycle";
import { useLocale } from "next-intl";

// const steps = [
//   {
//     step: "01",
//     title: "Planning",
//     desc: "Define project scope, objectives, timelines, and resources to ensure a clear roadmap.",
//   },
//   {
//     step: "02",
//     title: "Gap Analysis",
//     desc: "Analyze current processes versus system capabilities to identify gaps and requirements.",
//   },
//   {
//     step: "03",
//     title: "Data Migration",
//     desc: "Prepare, clean, and migrate business data securely into the new ERP system.",
//   },
//   {
//     step: "04",
//     title: "Development",
//     desc: "Configure and customize the ERP system to match approved business processes.",
//   },
//   {
//     step: "05",
//     title: "UAT",
//     desc: "User Acceptance Testing to validate system functionality and business readiness.",
//   },
//   {
//     step: "06",
//     title: "Training",
//     desc: "Train end-users based on real roles and scenarios to ensure smooth adoption.",
//   },
//   {
//     step: "07",
//     title: "Testing",
//     desc: "Perform functional and technical testing to ensure system stability and accuracy.",
//   },
//   {
//     step: "08",
//     title: "Going Live",
//     desc: "Launch the system in a controlled production environment with full support.",
//   },
//   {
//     step: "09",
//     title: "Maintenance & Technical Support",
//     desc: "Ongoing support, monitoring, and optimization after go-live.",
//   },
// ];

export default function WhyChooseLogicHub() {
  const scrollToSection = () => {
    const el = document.getElementById("contact");
    el?.scrollIntoView({ behavior: "smooth" });
  };

  const locale = useLocale();

  return (
    <section className="relative overflow-hidden bg-[#f7f9fc] py-32">
      {/* Ambient Background */}
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-1/4 top-0 h-120 w-120 -translate-y-1/2 rounded-full bg-[#c9a24d]/10 blur-[140px]" />
        <div className="absolute bottom-0 right-0 h-104 w-104 translate-y-1/2 rounded-full bg-[#0a1b2e]/10 blur-[140px]" />
      </div>

      <div className="mx-auto max-w-7xl space-y-32 px-6">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mx-auto max-w-4xl text-center"
        >
          <h2 className="mb-6 text-4xl font-black leading-tight text-[#0a1b2e] md:text-5xl">
            {locale === "en" ? "Why Choose" : "لماذا تختار"}{" "}
            <span className="bg-linear-to-r from-[#0a1b2e] to-[#c9a24d] bg-clip-text text-transparent">
              LogicHub
            </span>
          </h2>
          <p className="text-xl font-medium text-[#132b44]">
            {locale === "en"
              ? "We don’t implement ERP systems."
              : "نحن لا نقوم بتنفيذ أنظمة ERP."}
            <br />
            {locale === "en"
              ? "We engineer operational clarity and execution discipline."
              : "نحن نصمم وضوح العمليات وانضباط التنفيذ."}
          </p>
        </motion.div>

        {/* Pillars */}
        <Pillars />
        {/* How We Work */}
        <Cycle />

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="rounded-3xl bg-[#0a1b2e] px-8 py-16 text-center shadow-2xl"
        >
          <h3 className="mb-4 text-3xl font-black text-white">
            {locale === "en"
              ? "Ready to Build an ERP That Actually Works?"
              : "هل أنت مستعد لبناء نظام ERP يعمل بالفعل؟"}
          </h3>
          <p className="mb-10 text-lg text-[#e6c77a]">
            {locale === "en"
              ? "Let’s discuss your operations before discussing software."
              : "دعنا نناقش عملياتك قبل مناقشة البرنامج."}
          </p>

          <button
            onClick={scrollToSection}
            className="inline-flex items-center gap-3 rounded-xl bg-linear-to-r from-[#c9a24d] to-[#e6c77a] px-10 py-4 font-bold text-[#0a1b2e] transition hover:scale-105 cursor-pointer"
          >
            {locale === "en" ? "  Start a Conversation" : "ابدأ محادثة"} <br />
            <ArrowRight />
          </button>
        </motion.div>
      </div>
    </section>
  );
}
